import React, { useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './index.css'
import Loading from './components/Loading'
import { sendPageTypeDataToAnalytics } from '../../common/GoogleTagManager'
import VoidPage from '../VoidPage'
import texts from '../../common/texts.json'
import getConfig from '../../../src/Helpers/getConfig'

const VoidPLP = ({ thereAreProducts, children, categories, relatedProduct, isMobile, showCarousel }) => {
  const { VOID_PLP, VOID_PLP_WALSTORE, COMMON } = texts
  const isWalstore = getConfig('isWalstore')

  const text = isWalstore ? VOID_PLP_WALSTORE : VOID_PLP

  useEffect(() => {
    if (thereAreProducts && thereAreProducts !== null) sendPageTypeDataToAnalytics('PLP')

    if (!thereAreProducts && thereAreProducts !== null) sendPageTypeDataToAnalytics('PLP-not-found')
  }, [thereAreProducts])

  const message = () => (
    <Fragment>
      {text.TEXT[0]}
      {COMMON.SPACE}
      <Link to="/">{text.TEXT[1]}</Link>
      {COMMON.SPACE}
      {text.TEXT[2]}
    </Fragment>
  )

  if (thereAreProducts === null) return <Loading />
  if (thereAreProducts) {
    return (
      <div>
        {showCarousel === null && <Loading onlyCarousel />}
        {children}
      </div>
    )
  }
  return (
    <VoidPage
      title={text.TITLE}
      subtitle={text.SUBTITLE}
      message={message()}
      isMobile={isMobile}
      categories={categories}
      relatedProduct={relatedProduct}
    />
  )
}

VoidPLP.defaultProps = {
  thereAreProducts: null,
  categories: [],
  relatedProduct: [],
  isMobile: false,
  showCarousel: null,
}

VoidPLP.propTypes = {
  thereAreProducts: PropTypes.bool,
  children: PropTypes.node.isRequired,
  categories: PropTypes.array,
  relatedProduct: PropTypes.array,
  isMobile: PropTypes.bool,
  showCarousel: PropTypes.bool,
}

export default VoidPLP
